import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  get,
  noop,
  orderBy,
  sortBy,
  sumBy,
  includes,
  toLower,
} from 'lodash';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
} from 'recompose';
import moment from 'moment';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ProductItemImage from './../../Store/components/ProductItemImage';
import immutableToJS from 'helpers/immutableToJS';
import {
  dispatchRestMaker,
  formatPrice,
  getCaptureMoment,
  getOrderStatus,
  addTagValue,
  toDefaultDateTimeFormat,
  updatedClassname,
  decimalFixed,
} from 'helpers/utils';
import {
  InvoiceBadge,
  SmartTable,
  Tags,
  HighlightText,
} from 'components';
import { Container, Col, Row } from 'reactstrap';
import { FRInput } from 'elements';
import orderItemsActions from 'redux/orderItems/actions';
import memberActions from 'redux/members/actions';
import { sendOrderUpdateEmail } from 'redux/orders/actions';
import { selectState } from 'redux/selectors';
import TopPanel from './TopPanel';
import Lightbox from 'react-images';

const styles = () => ({
  red: {
    color: 'red',
    marginRight: 5,
  },
  chipRedSmall: {
    borderRadius: 3,
    color: '#000',
    fontSize: 12,
    fontWeight: 600,
    height: 20,
    lineHeight: '20px',
    paddingLeft: 5,
    paddingRight: 5,
  },
  chipSmall: {
    borderRadius: 3,
    color: '#000',
    fontSize: 10,
    fontWeight: 400,
    height: 20,
    lineHeight: '20px',
    paddingLeft: 5,
    paddingRight: 5,
  },
  chipAO: {
    backgroundColor: '#79b36c',
    height: 20,
    marginBottom: 6,
    marginRight: 2,
    marginTop: 6,
  },
  chipPO: {
    backgroundColor: '#ff9800',
    height: 20,
    marginBottom: 6,
    marginRight: 2,
    marginTop: 6,
  },
  chip: {
    height: 20,
    marginBottom: 6,
    marginRight: 2,
    marginTop: 6,
    width: 20,
  },
  chipSO: {
    backgroundColor: '#6097e0',
    height: 20,
    marginBottom: 6,
    marginRight: 2,
    marginTop: 6,
  },
  chipColor: { color: 'white' },
  btnSaveAndEmail: {
    backgroundColor: '#35b561',
    color: 'white',
  },
  btnDisabled: {
    backgroundColor: '#D1D0D1',
  },
  flexWrap: {
    display: 'flex',
    flexWrap: 'wrap',
  },
});

class InvoiceDetail extends Component {
  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    editDisabled: PropTypes.bool,
    globals: PropTypes.arrayOf(PropTypes.shape({})),
    order: PropTypes.shape({
      id: PropTypes.number,
    }),
    orderRequesting: PropTypes.bool,
    tags: PropTypes.arrayOf(PropTypes.shape({})),

    formatMessage: PropTypes.func.isRequired,
    readOrder: PropTypes.func.isRequired,
    sendOrderUpdateEmail: PropTypes.func,
    readOrder: PropTypes.func,
    updateOrder: PropTypes.func,
    updateOrderItem: PropTypes.func,
    isTrackOrderPage: PropTypes.bool,
    listMembers: PropTypes.func.isRequired,
    members: PropTypes.arrayOf(
      PropTypes.shape({}),
    ).isRequired,
  };

  static defaultProps = {
    editDisabled: false,
    globals: [],
    order: {},
    orderRequesting: false,
    tags: [],

    sendOrderUpdateEmail: noop,
    readOrder: noop,
    updateOrder: noop,
    updateOrderItem: noop,
    isTrackOrderPage: false,
  };

  static contextTypes = {
    currentUser: PropTypes.shape({}),
    isRestaurant: PropTypes.bool,
    isDistributor: PropTypes.bool,
    isFarmer: PropTypes.bool,
    noAutoPay: PropTypes.bool,
    readOnly: PropTypes.bool,
    setHotNotification: PropTypes.func,
  };

  state = {
    pristine: true,
    currentActivity: {},
    currentImage: 0,
    lightboxIsOpen: false,
    showMode: true,
  };

  componentWillMount() {
    const { order, listMembers } = this.props;
    if (order.buyer && order.buyer.account) {
      listMembers({ buyerEmail: order.buyer.account.email });
    }
  }

  openLightbox = (item) => {
    const imageIndex = this.lightboxImages.findIndex(i => i.itemId === item.id);

    this.setState({ currentImage: imageIndex >= 0 ? imageIndex : 0, lightboxIsOpen: true });
  }
  openLightbox = (item) => {
    const imageIndex = this.lightboxImages.findIndex(i => i.itemId === item.id);

    this.setState({ currentImage: imageIndex >= 0 ? imageIndex : 0, lightboxIsOpen: true });
  }

  closeLightbox = () => this.setState({ currentImage: 0, lightboxIsOpen: false })

  gotoPreviousImage = () => this.setState({ currentImage: this.state.currentImage - 1 })

  gotoNextImage = () => this.setState({ currentImage: this.state.currentImage + 1 })

  gotoImage = index => this.setState({ currentImage: index })

  handleClickLightboxImage = () => {
    if (this.state.currentImage === this.lightboxImages.length - 1) return;
    this.gotoNextImage();
  }

  onClickActivity = (activity) => {
    this.setState({ currentActivity: activity });
  };

  getData = () => {
    const { isFarmer, isDistributor, currentUser } = this.context;
    const { order, tags } = this.props;
    const orderItemsWithDiff = [];
    if (order.orderActivities) {
      (orderBy(order.orderActivities, ['updatedAt'], ['desc'])).forEach((orderAct) => {
        if (orderAct.field === 'quantity') {
          orderItemsWithDiff.push({
            storeItemId: orderAct.orderItem.storeItemId,
            editorId: orderAct.editorId,
            editorMember: orderAct.editorMember,
          });
        }
      });
    }

    const orderItems = [];

    const groupItems = [];
    (order.orderItems || []).forEach((orderItem) => {
      groupItems.push({
        ...orderItem,
        tags: get(orderItem, 'data.tags'),
      });
      return groupItems;
    });

    const addedTagsGroupItems = addTagValue(groupItems || [], tags);

    const sortedOrderItems = sortBy(addedTagsGroupItems || [], ['data.productData.category', 'data.productData.name', 'data.productData.subname', 'packrow.count', 'tagValue'], ['asc', 'asc', 'asc', 'asc', 'asc']);
    sortedOrderItems.forEach((orderItem) => {
      const qtyDiff = orderItem.quantity - orderItem.refundQuantity
        - sumBy(orderItem.children || [], row => row.quantity - row.refundQuantity);
      let diff = '';
      if (orderItem.children && orderItem.children.length && qtyDiff !== 0) {
        const orderItemsFilteredList = orderBy(orderItemsWithDiff, ['updatedAt'], ['desc']).filter(item => item.storeItemId === orderItem.storeItemId);
        const isUpdatedByDistributor = orderItemsFilteredList &&
          orderItemsFilteredList.length > 0 &&
          orderItemsFilteredList[0].editorId === currentUser.id &&
          !orderItemsFilteredList[0].editorId.editorMember ? 1 : 0;

        if (isDistributor) {
          diff = isUpdatedByDistributor ? `${qtyDiff > 0 ? 'Vendor must Reduce Qty by ' : 'Vendor must Increase Qty by '}${decimalFixed(qtyDiff)}` : `${qtyDiff > 0 ? 'You must Increase Qty by' : 'You must Reduce Qty by '}${decimalFixed(qtyDiff)}`;
        } else {
          diff = isUpdatedByDistributor ? `${qtyDiff > 0 ? 'Distributor must Increase Qty by ' : 'Distributor must Reduce Qty by '}${decimalFixed(qtyDiff)}` : `${qtyDiff > 0 ? 'Reduce Qty by ' : 'Increase Qty by '}${decimalFixed(qtyDiff)}`;
        }
      }
      const { packrow, orderId } = orderItem;
      const packrows = get(orderItem, 'storeItem.packrows') || get(orderItem, 'good.packrows');
      const itemPackrows = packrows && packrows.length > 0 ? packrows.filter(pr => pr.count === packrow.count) : [];
      const availableQuantity = itemPackrows && itemPackrows.length > 0 ? itemPackrows[0].availableQuantity : 0;
      orderItems.push({
        orderId,
        category: get(orderItem, 'data.productData.category'),
        cost: packrow.cost || 0,
        count: packrow.count,
        storeItemId: orderItem.storeItemId,
        parentOrderId: get(orderItem, 'parent.orderId'),
        parentOrderDiscount: get(orderItem, 'parent.order.discount'),
        customername: get(order, 'buyer.account.profile.companyName'),
        isParent: true,
        diff,
        className: 'bold',
        discount: get(order, 'discount'),
        discounted: (((packrow.price || 0) * (100 - (parseFloat(order.discount)))) / 100).toFixed(2),
        editable: order.type === 'SO' && !order.captured,
        editorId: get(orderItem, 'editorId'),
        editorMember: get(orderItem, 'editorMember'),
        editorMemberId: get(orderItem, 'editorMemberId'),
        finalUOM: `${packrow.count} ${packrow.uom} ${packrow.pack}`,
        id: get(orderItem, 'id'),
        name: get(orderItem, 'data.productData.name'),
        pack: packrow.pack || '',
        price: packrow.price || 0,
        qtyDiff,
        quantity: get(orderItem, 'quantity'),
        refundQuantity: get(orderItem, 'refundQuantity'),
        sourcename: get(orderItem, 'data.seller.companyName') || get(order, 'seller.account.profile.companyName'),
        status: getOrderStatus(order),
        subname: get(orderItem, 'data.productData.subname'),
        tags: get(orderItem, 'data.tags'),
        uom: packrow.uom || '',
        updatedAt: get(orderItem, 'updatedAt'),
        payMethod: order.payMethod,
        captureScheduledAt: get(order, 'captureScheduledAt'),
        description: get(orderItem, 'data.description'),
        image: get(orderItem, 'data.image'),
        availableQuantity,
        mergedAt: get(orderItem, 'mergedAt'),
      });

      if (orderItem.children) {
        orderItem.children.forEach((child) => {
          orderItems.push({
            category: get(child, 'data.productData.category'),
            customername: get(child, 'order.buyer.account.profile.companyName'),
            isParent: false,
            diff: diff ? `(${get(child, 'quantity')} ${diff})` : `(ordered a qty of ${get(child, 'quantity')})`,
            className: 'normal',
            discount: get(child, 'discount'),
            editable: !get(child, 'order.captured') && !isFarmer,
            editorId: get(child, 'editorId'),
            editorMember: get(orderItem, 'editorMember'),
            editorMemberId: get(orderItem, 'editorMemberId'),
            hide: [
              'category',
              'name',
              'price',
              'price-based-discount',
              'priceTotal',
              'subname',
              'uom',
            ],
            id: get(child, 'id'),
            isChild: true,
            order: get(child, 'order'),
            orderId: get(child, 'order.id'),
            parentOrderId: orderId,
            price: child.packrow.price || 0,
            quantity: get(child, 'quantity'),
            refundEditable: !get(child, 'order.captured'),
            refundQuantity: get(child, 'refundQuantity'),
            status: child.order ? getOrderStatus(child.order) : '',
            payMethod: child.order ? child.order.payMethod : '',
            tags: get(child, 'data.tags'),
            updatedAt: get(child, 'updatedAt'),
            captureScheduledAt: get(child.order, 'captureScheduledAt'),
            mergedAt: get(orderItem, 'mergedAt'),
          });
        });
      }
    });

    // const categoryField = r => r.category;
    // const sortedGroupItems = orderBy(
    //   addTagValue(orderItems, tags),
    //   [categoryField, 'tagValue'],
    //   ['asc', 'asc'],
    // );
    return orderItems;
  }

  getFields = (isMobile = false, hasParentDiscountOrder = false) => {
    const {
      classes,
      editDisabled,
      formatMessage,
      order,
    } = this.props;
    const {
      currentUser,
      isDistributor,
      isFarmer,
      isRestaurant,
      readOnly,
      setHotNotification,
    } = this.context;
    const buyerRoleId = get(order, 'buyer.roleId');
    const buyerRole = {
      2: 'Buyer',
      3: 'Distributor',
      4: 'Seller',
      5: 'Consumer',
    }[buyerRoleId] || 'Personal';
    let fields = [];
    const conditionSOBuyer = !isRestaurant && buyerRole === 'Buyer' && order.type === 'SO' && !order.captured;

    const quantityField = row => (
      (get(order, 'contact.isDeleted') ||
        !row.editable ?
        (
          <div style={{ width: '90px' }}>
            <span
              className={(isFarmer ? (row.isChild ?
                (order.type === 'SO' ? 'grey italic' : 'child-italic red') :
                ('child-italic')) : (row.isChild ?
                  (order.type === 'PO' ? 'child-italic child-opacity red' : '') :
                  ('not-child-italic')))}
              style={{ marginLeft: 5 }}
            > 
              {!row.quantity && '0'}
              {!!row.quantity && row.quantity - (row.refundQuantity || 0)}
              {isFarmer && row.isChild ? (<span> > </span>) : ''}
              {!!row.quantity && row.refundQuantity > 0 ? (
                <span className="italic">
                  <span>{` (${row.quantity}`}</span>
                  <span className="red">{`-${row.refundQuantity})`}</span>
                </span>) : ''}
            </span>
            <span className={`diff ${(isFarmer ? (row.isChild ?
              (order.type === 'SO' ? 'italic' : 'child-italic') :
              ('child-italic')) : (row.isChild ?
                (order.type === 'PO' ? 'child-italic' : 'italic') :
                ('not-child-italic')))}`}>
              {!row.isChild && row.diff}
            </span>
          </div>
        ) :
        (
          <Fragment>
            <FRInput
              className={(isFarmer ? (row.isChild ?
                (order.type === 'SO' ? 'italic' : 'child-italic') :
                ('child-italic red')) : (row.isChild ?
                  (order.type === 'PO' ? 'child-italic child-opacity red' : 'italic') :
                  (isRestaurant ? 'not-child-italic-rest' : 'not-child-italic red')))}
              defaultValue={!row.quantity ? 0 : row.quantity}
              disabled={ (order.createdAsDraft && isFarmer) || readOnly || editDisabled }
              id={conditionSOBuyer ? "quantity" : "blackQuantity"}
              key={row.quantity}
              min={1}
              name="quantity"
              onBlur={({ target: { value }, target }) => {
                if (value !== row.quantity) {
                  const originalQuantity = row.quantity;
                  if ((value || 0) < 0) {
                    setHotNotification('Should not be less than 0.');
                    return;
                  }
                  if(originalQuantity != value){
                    this.handleUpdateOrderItem(row, { quantity: value }, target, originalQuantity);
                  }
                }
              }}
              onChange={function onChange(event) {
                event.preventDefault();
                const { target: { value }, target } = event;
                if ((value || 0) < 0) {
                  setHotNotification('Should not be less than 0.');
                }
                event.target.value = value;
              }}
              style={{ width: 70, fontSize: 12, marginLeft: 5 }}
              title={formatMessage('Qty')}
              type="number"
            />
            <span className={`diff ${(isFarmer ? (row.isChild ?
              (order.type === 'SO' ? 'italic' : 'child-italic') :
              ('child-italic')) : (row.isChild ?
                (order.type === 'PO' ? 'child-italic' : 'italic') :
                ('not-child-italic')))}`}>
              {!row.isChild && row.diff}
            </span>
          </Fragment>
        ))
    );

    if (isMobile) {
      fields = [

        {
          label: formatMessage('IN'),
          name: 'name',
          render: row => (
            <div className="mobile-group-data-first">
              <div className={'mobile-group-data-item mr-2 highlight weight-500'}
                style={{ fontSize: '20px' }}
              >
                <HighlightText
                  highlight={''}
                  text={[row.name, row.subname].join(', ')}
                />
              </div>
              {
                row.tags ? (
                  <div className={classes.flexWrap}>
                    <Tags
                      approved={row.approved}
                      defaultTags={row.tags}
                      removable={false}
                      showDropdown={false}
                      size="small"
                    />
                  </div>
                ) : null
              }
              {
                <div className="ml-2">
                  {row.image ? (
                    <img
                      src={row.image}
                      alt={row.image}
                      style={{
                        height: 50,
                        objectFit: 'unset',
                        width: 50,
                        cursor: 'pointer',
                      }}
                      onClick={() => this.openLightbox(row)}
                    />
                  ) : null}
                </div>
              }
            </div>
          ),
        },
        {
          label: formatMessage('ISN'),
          name: 'subname',
          render: row => (
            <Container>
              {(isFarmer || isDistributor) && order.createdAsDraft ? (
                <Row>
                  <Col style={{ padding: 0 }}><div className="highlight bold d-flex align-items-end" style={{ height: '100%' }}>{row.finalUOM}</div></Col>
                </Row>
              ) : (
                  <Row>
                    <Col style={{ padding: 0 }} className="col-3"><div className="highlight item-qty-font red d-flex align-items-end" style={{ height: '100%' }}>{quantityField(row)}</div></Col>
                    <Col style={{ padding: 0 }} className="col-4"><div className="highlight font-weight-500 d-flex align-items-end" style={{ height: '100%' }}>{row.finalUOM} </div></Col>
                    <Col style={{ padding: 0 }} className="col-5">
                      <div className="d-flex align-items-end" style={{ textAlign: 'right', height: '100%', justifyContent:'flex-end' }}>
                        <span>{`@ $${formatPrice(((row.price * (100 - (row.discount || 0))) / 100).toFixed(2))}`}</span>
                        <span className="font-weight-500">{`= $${(((row.price * (100 - (row.discount || 0))) / 100) * row.quantity).toFixed(2)}`}</span>
                      </div>
                    </Col>
                  </Row>
                )
              }
            </Container>
          ),
        },
        {
          label: formatMessage('info'),
          name: 'description',
          render: row => ( 
            <div style={{marginTop: '10px'}} >
              {row.description}
            </div> ),
          title: row => row.description,
        },
        {
          label: formatMessage('Customer'),
          name: 'customername',
          render: row => (
            <div>
            {(isFarmer || isDistributor) && order.createdAsDraft ? (
              <div className="customer-pane">
                <Container>
                  <Row>
                    <Col xs={3} style={{ padding: 0 }}>
                      <div className="highlight big-font d-flex align-items-end" style={{ height: '100%' }}>  {quantityField(row)}
                      </div>
                    </Col>
                    <Col xs={4} style={{ padding: 0 }}>
                      <span className={(isFarmer ? (row.isChild ?
                        (order.type === 'SO' ? 'italic child-opacity' : 'child-italic') :
                        (row.sourcename ? 'child-italic' : null)) : (row.isChild ?
                          (order.type === 'PO' ? 'italic child-opacity' : 'italic') :
                          (row.sourcename ? 'not-child-italic' : null)))}>
                        {
                          order.createdAsDraft && (
                            <span>
                              <Chip
                                classes={{
                                  label: `${classes.chipSmall} ${classes.chipColor}`,
                                  root: row.isChild ? classes.chipSO : (isDistributor && order.type === 'PO') ? classes.chipPO : classes.chipAO,
                                }}
                                label={row.isChild ? 'SO' : (isDistributor && order.type === 'PO') ? 'PO' : 'AO'}
                                onDelete={null}
                              />
                            </span>
                          )
                        }
                        {row.customername}
                      </span>
                    </Col>
                    <Col xs={5} style={{ padding: 0 }}>
                      {
                        row.isParent && (
                          <div className="d-flex" style={{ textAlign: 'right', height: '100%', alignItems: 'center',justifyCcontent: 'flex-end' }}>
                            <span>{`@ $${formatPrice(((row.price * (100 - (row.discount || 0))) / 100).toFixed(2))}`}</span>

                            <span className="font-weight-500">{`= $${(((row.price * (100 - (row.discount || 0))) / 100) * row.quantity).toFixed(2)}`}</span>
                          </div>
                        )
                      }
                    </Col>
                  </Row>
                </Container>
              </div>
            ) : null
          }
          </div>
          )
          
        },
        {
          className: 'category2',
          label: formatMessage('Category'),
          name: 'category',
          render: row => (
            <div>
              {!order.createdAsDraft ? (
                <div className="item-details-row container">
                  <div className="row">
                    <div style={{ padding: 0, textAlign: 'start' }} className="item-details-sourcename col-6">
                      {order.type === 'PO' ? row.sourcename : row.customername}
                    </div>
                    <div style={{ padding: 0, textAlign: 'end' }} className="item-details-category col-6">
                      {row.category}
                    </div>
                  </div>
                </div>
              ) : null
              }
            </div>
          )
        }

      ];
    } else {
      fields = [
        {
          className: `${isFarmer ? 'category-title' : 'category'}`,
          colSpan: 2,
          label: formatMessage('Category'),
          name: 'category',
        },
        {
          className: 'highlight item-name-font',
          colSpan: 3,
          label: formatMessage('IN'),
          name: 'name',
        },
        {
          className: 'highlight item-name-font',
          colSpan: 3,
          label: formatMessage('ISN'),
          name: 'subname',
        },
        {
          className: 'highlight tiny-font',
          colSpan: 3,
          label: formatMessage('Info'),
          name: 'description',
          render: row =>  (
            <span style ={{lineHeight:'15px'}}>
            {row.description ? (`${row.description.substr(0, 20)}${row.description.length > 20 ? '...' : ''}`) : ''}
            </span>
          ),
        },
        {
          colSpan: 3,
          label: formatMessage('Tags'),
          name: 'tags',
          render: data => (
            <div className={(isFarmer ? '' : (data.isChild ? (order.type === 'PO' ? 'child-opacity' : '') : ''))} style={{ alignItems: 'center', display: 'flex' }}>
              {
                !data.isChild && !!data.tags.length && (
                  <Tags
                    defaultTags={data.tags}
                    removable={false}
                    showDropdown={false}
                    size="small"
                  />
                )
              }
            </div>
          ),
        },
      ];

      fields.push({
        label: formatMessage('Qty'),
        name: 'quantity',
        render: quantityField,
        cellClassName: row => ((includes(toLower(row.diff || ''), 'increase') || includes(toLower(row.diff || ''), 'reduce')) ? 'warning-bg' : ''),
      });
      if (conditionSOBuyer) {
        fields.push(
          {
            colSpan: 2,
            label: formatMessage(' '),
            mobileHidden: true,
            name: 'availableQuantity',
            render: data => data.availableQuantity && (
              <span>
                <span style={{ color: 'red' }} >{Math.trunc(data.availableQuantity)}</span> <i>left</i>
              </span>
            ),
          },
        );
      }
      fields.push(
        {
          className: 'font-weight-500',
          colSpan: 2,
          label: formatMessage('Pack-Out'),
          mobileHidden: true,
          name: 'finalUOM',
        },
      );
      if (isRestaurant || (isDistributor && order.type === 'SO')) {
        fields.push({
          className: row => (row.sourcename ? 'italic' : null),
          colSpan: 2,
          label: formatMessage('Vendor'),
          name: 'sourcename',
        });
      } else if ((isDistributor && order.type === 'PO') || (!isDistributor && !isRestaurant && buyerRole !='Consumer')) {
        fields.push({
          colSpan: 3,
          label: formatMessage('Customer'),
          name: 'customername',
          render: row => (
            <div className="customer-pane">
              <span className={(isFarmer ? (row.isChild ?
                (order.type === 'SO' ? 'italic child-opacity' : 'child-italic') :
                (row.sourcename ? 'child-italic' : null)) : (row.isChild ?
                  (order.type === 'PO' ? 'italic child-opacity' : 'italic') :
                  (row.sourcename ? 'not-child-italic' : null)))}>
                {
                  order.createdAsDraft && (
                    <span>
                      <Chip
                        classes={{
                          label: `${classes.chipSmall} ${classes.chipColor}`,
                          root: row.isChild ? classes.chipSO : (isDistributor && order.type === 'PO') ? classes.chipPO : classes.chipAO,
                        }}
                        label={row.isChild ? 'SO' : (isDistributor && order.type === 'PO') ? 'PO' : 'AO'}
                        onDelete={null}
                      />
                    </span>
                  )
                }
                {row.customername}
              </span>
            </div>),
        });
      }

      if (isDistributor && order.type === 'SO') {
        fields.push({
          label: formatMessage('Cost'),
          name: 'cost',
          render: data => Boolean(data.storeItemId) && (
            <span className={data.parentOrderDiscount !== '0' && data.cost > 0 ? 'strike' : ''}>
              ${formatPrice(data.cost.toFixed(2))}
            </span>
          ),
        });
      }
      if (hasParentDiscountOrder) {
        fields.push({
          label: formatMessage('Discounted'),
          name: 'cost-based-discount',
          render: data => Boolean(data.storeItemId) && data.parentOrderDiscount !== '0' && data.cost > 0 &&
            `$${formatPrice(((data.cost * (100 - (parseFloat(data.parentOrderDiscount) || 0))) / 100).toFixed(2))}`,
        });
      }

      fields.push({
        label: isFarmer || isRestaurant || (isDistributor && order.type === 'SO')
          ? formatMessage('Price')
          : formatMessage('Cost'),
        name: 'price',
        render: data => (
          <span className={order.type === 'PO' ? 'blue' : ''}>
            @&nbsp;
            <span className={`${order.type === 'PO' ? 'blue' : ''} ${order.discount !== '0' ? 'strike' : ''}`}>
              {`$${formatPrice(data.price)}`}
            </span>
          </span>
        ),
      });
      if (order.discount > 0) {
        fields.push({
          label: formatMessage('Discounted'),
          name: 'price-based-discount',
          render: data => `$${formatPrice(((data.price * (100 - (parseFloat(order.discount) || 0))) / 100).toFixed(2))}`,
        });
      }
      fields.push({
        label: formatMessage('Total'),
        name: 'priceTotal',
        render: data => (
          <span>
            <span className="font-weight-400">=&nbsp;</span>
            <span className="font-weight-500">
              ${(((data.price * (100 - (parseFloat(order.discount) || 0))) / 100) *
                (data.quantity - data.refundQuantity)).toFixed(2)}
            </span>
          </span>
        ),
      });
      if (isDistributor && order.type === 'SO') {
        fields.push({
          label: formatMessage('Profit'),
          name: 'profit',
          render: data => `$${((((data.price * (100 - (parseFloat(order.discount) || 0))) / 100) * (data.quantity - data.refundQuantity)) - (data.cost * ((100 - (parseFloat(data.parentOrderDiscount) || 0)) / 100) * (data.quantity - data.refundQuantity))).toFixed(2)}`,
        });
      }
      // if (isFarmer) {
      //   fields.push({
      //     label: formatMessage('Member'),
      //     name: 'member',
      //     render: data => `${get(data, 'editorMember.profile.firstName') || ''} ${get(data, 'editorMember.profile.lastName') || ''}`,
      //   });
      // }
      if (!isFarmer && !isDistributor && !isRestaurant && buyerRole !='Consumer') {
        fields.push({
          label: formatMessage('Status'),
          name: 'status',
          render: data => (data.status ? (
            <InvoiceBadge type={data.status}>
              {formatMessage((get(data, 'payMethod') ? (get(data, 'payMethod') === 'coin' ? 'balance' : get(data, 'payMethod')) : 'manual')).toUpperCase()}{getCaptureMoment(data)}
            </InvoiceBadge>) : ''),
          title: data => data.status,
        });
      }
      if (!isFarmer && !isDistributor && !isRestaurant && buyerRole !='Consumer') {
        fields.push({
          label: formatMessage('Update'),
          className: row => (row.editorId === currentUser.id || row.editorMemberId === currentUser.id ? 'grey' : 'red'),
          colSpan: 2,
          mobileHidden: true,
          name: 'updatedAt',
          render: data => toDefaultDateTimeFormat(data.updatedAt),
        });
      }
    }
    const isDistributorAndSO = order.type === 'SO' && isDistributor;
    if (buyerRole !='Consumer'){
      fields.push({
        label: formatMessage('Time-stamp'),
        className: row => ((row.editorId === currentUser.id && isDistributor) || (row.editorId != currentUser.id && isRestaurant) || (row.mergedAt && isDistributorAndSO) ? 'tiny-font red' : 'tiny-font gray'),
        colSpan: 2,
        mobileHidden: true,
        name: 'updatedAt',
        render: data => (data.mergedAt && isDistributorAndSO ? toDefaultDateTimeFormat(data.mergedAt) : toDefaultDateTimeFormat(data.updatedAt)),
      })
    }

    return fields;
  }

  handleEmailCustomer = () => {
    const { order, sendOrderUpdateEmail } = this.props;
    sendOrderUpdateEmail(order.id);
    this.setState({ pristine: true });
  };

  handleUpdateOrder = (payload) => {
    const { order, updateOrder } = this.props;
    updateOrder(order.id, payload);
    this.setState({ pristine: false });
  };

  handleUpdateOrderItem = ({ id }, payload, target, originalQuantity) => {
    const { readOrder, updateOrderItem } = this.props;
    updateOrderItem(id, {
      ...payload,
      onSuccess: (data) => {
          data.relatedOrderIds.forEach(
            relatedOrderId => readOrder(relatedOrderId),
          );
      },
      onFailure: () => {
        // Set original quantity to input
        target.value = originalQuantity;
      },
    });
    this.setState({ pristine: false });
  };

  buyerConfirmOrder = () => {
    this.handleUpdateOrder({ buyerConfirmed: true });
  };

  changeDeliveryDate = (event, date) => {
    this.handleUpdateOrder({ deliveryDate: moment(date).format('YYYY-MM-DD') });
  };

  changeDiscountValue = (event) => {
    const newDiscountValue = event.target.value;
    this.handleUpdateOrder({ discount: newDiscountValue });
  };

  changeFromAddress = (sellerAddress) => {
    this.handleUpdateOrder({ sellerAddress });
  }

  changeToAddress = (buyerAddress) => {
    this.handleUpdateOrder({ buyerAddress });
  }

  confirmDeliveryOrder = () => {
    this.handleUpdateOrder({ delivered: true });
  };

  validateDeliveryFeeChange = ({ target }) => {
    const { setHotNotification } = this.context;
    const { globals, formatMessage } = this.props;
    const maxDeliveryFeeGlobal = globals.find(g => g.name === 'maxDeliveryFee') || {};
    const maxDeliveryFee = maxDeliveryFeeGlobal.value || 0;
    const value = parseFloat(target.value);

    if (value > maxDeliveryFee) {
      setHotNotification(formatMessage('BEYOND_MAX_DELIVERY_FEE'));
      target.value = '';
      return;
    }
    if (value < 0) {
      setHotNotification(formatMessage('LESS_THAN_0'));
      target.value = '';
      return;
    }
  };

  handleDeliveryFeeChange = ({ target }) => {
    const { setHotNotification } = this.context;
    const { globals, formatMessage, order } = this.props;
    const maxDeliveryFeeGlobal = globals.find(g => g.name === 'maxDeliveryFee') || {};
    const maxDeliveryFee = maxDeliveryFeeGlobal.value || 0;
    const value = parseFloat(target.value);

    if (target.value == '') {
      target.value = order.deliveryFee.toFixed(2);
    } else {
      if (value > maxDeliveryFee) {
        setHotNotification(formatMessage('BEYOND_MAX_DELIVERY_FEE'));
        return;
      }
      if (value < 0) {
        setHotNotification(formatMessage('LESS_THAN_0'));
        return;
      }
      this.handleUpdateOrder({ deliveryFee: value });
    }

  };

  validateReductionChange = ({ target }) => {
    const { setHotNotification } = this.context;
    const { formatMessage } = this.props; // globals,

    const value = parseFloat(target.value);

    if (value < 0) {
      setHotNotification(formatMessage('LESS_THAN_0'));
      target.value = '';
      return;
    }
  };

  handleReductionChange = ({ target }) => {
    const { setHotNotification } = this.context;
    const { formatMessage, order } = this.props; // globals,

    const value = parseFloat(target.value);

    if (target.value == '') {
      target.value = parseFloat(order.reduction || 0).toFixed(2);
    } else {
      if (value < 0) {
        setHotNotification(formatMessage('LESS_THAN_0'));
        return;
      }

      this.handleUpdateOrder({ reduction: value });
    }
  };

  validateCreditChange = ({ target }) => {
    const { setHotNotification } = this.context;
    const { formatMessage } = this.props; // globals,

    const value = parseFloat(target.value);

    if (value < 0) {
      setHotNotification(formatMessage('LESS_THAN_0'));
      target.value = '';
      return;
    }
  };

  handleCreditChange = ({ target }) => {
    const { setHotNotification } = this.context;
    const { formatMessage, order } = this.props; // globals,

    const value = parseFloat(target.value);

    if (target.value == '') {
      target.value = parseFloat(order.credit || 0).toFixed(2);
    } else {
      if (value < 0) {
        setHotNotification(formatMessage('LESS_THAN_0'));
        return;
      }

      this.handleUpdateOrder({ credit: value });
    }
  };

  validateTaxChange = ({ target }) => {
    const { setHotNotification } = this.context;
    const { formatMessage } = this.props; // globals,

    // const maxTaxGlobal = globals.find(g => g.name === 'maxTax') || {};
    // const maxTax = maxTaxGlobal.value || 0;
    const value = parseFloat(target.value);

    // if (value > maxTax) {
    //   setHotNotification(formatMessage('BEYOND_MAX_TAX'));
    //   return;
    // }
    if (value <= 0) {
      setHotNotification(formatMessage('LESS_THAN_0'));
      target.value = '';
      return;
    }
  };

  handleTaxChange = ({ target }) => {
    const { setHotNotification } = this.context;
    const { formatMessage, order } = this.props; // globals,

    // const maxTaxGlobal = globals.find(g => g.name === 'maxTax') || {};
    // const maxTax = maxTaxGlobal.value || 0;
    const value = parseFloat(target.value);

    if (target.value == '') {
      target.value = parseFloat(order.tax || 0).toFixed(2);
    } else {
      // if (value > maxTax) {
      //   setHotNotification(formatMessage('BEYOND_MAX_TAX'));
      //   return;
      // }
      if (value <= 0) {
        setHotNotification(formatMessage('LESS_THAN_0'));
        return;
      }
      this.handleUpdateOrder({ tax: value });

    }

  };

  placeOrder = () => {
    this.handleUpdateOrder({ isDraft: false });
  };

  sellerConfirmOrder = () => {
    this.handleUpdateOrder({ sellerConfirmed: true });
  };

  render() {
    const {
      classes,
      formatMessage,
      order,
      orderRequesting,
      editDisabled,
      updateOrder,
      readOrder,
      isTrackOrderPage,
      members,
    } = this.props;
    const {
      currentUser,
      isRestaurant,
      isFarmer,
    } = this.context;
    const { pristine, currentActivity,currentImage,lightboxIsOpen } = this.state;
    const allData = this.getData();
    let newAllData = [];
    if (order.createdAsDraft && isFarmer) {
      let parentOrderId = 0;
      allData.forEach((dataItem) => {
        if (dataItem.isParent && dataItem && (dataItem.quantity > 0 || dataItem.diff.indexOf('Reduce') >= 0 || dataItem.diff.indexOf('Increase') >= 0 ||
          (dataItem.editorId === currentUser.id && (dataItem.diff.indexOf('ordered') !== -1 || dataItem.qtyDiff === 0)))) {
          newAllData.push(dataItem);
          parentOrderId = Math.floor(dataItem.orderId);
        }
        if (!dataItem.isParent && dataItem.parentOrderId === parentOrderId && (dataItem.quantity > 0 || dataItem.diff.indexOf('Reduce') !== -1 || dataItem.diff.indexOf('Increase') !== -1)) {
          newAllData.push(dataItem);
        }
      });
    } else {
      newAllData = allData;
    }
    const data = newAllData;

    const hasParentOrderDiscount = data.find(
      ({ parentOrderDiscount, cost }) => parentOrderDiscount > 0 && cost > 0,
    );
    const fields = this.getFields(false, hasParentOrderDiscount);
    const fieldsForMobile = this.getFields(true, hasParentOrderDiscount);
    const totalDue = parseFloat(sumBy(data, item => !item.hide &&
      (item.price *
        (item.quantity - item.refundQuantity)))).toFixed(2);
    const refundedAmount = parseFloat(sumBy(data, item => !item.hide &&
      ((item.price * (100 - (item.discount || 0))) / 100) *
      (item.refundQuantity))).toFixed(2);
    if (!order.id) return null;
    const sortableFields = [
      'category',
      'name',
      'subname',
    ];

    this.lightboxImages = data.filter(g => (!g.hide) && !!g.image)
    .map(({ id, image, productData }) => ({
      itemId: id,
      src: image,
    }));
    return (
      <div className="invoice-detail">
        <TopPanel
          changeDeliveryDate={this.changeDeliveryDate}
          changeFromAddress={this.changeFromAddress}
          changeToAddress={this.changeToAddress}
          currentUser={currentUser}
          data={data}
          fields={fields}
          formatMessage={formatMessage}
          editDisabled={editDisabled}
          info={order}
          updateOrder={updateOrder}
          readOrder={readOrder}
          currentActivity={currentActivity}
          onClickActivity={this.onClickActivity}
          orderRequesting={orderRequesting}
          refundedAmount={refundedAmount}
          totalDue={totalDue}
          validateDeliveryFee={this.validateDeliveryFeeChange}
          changeDeliveryFee={this.handleDeliveryFeeChange}
          validateTax={this.validateTaxChange}
          changeTax={this.handleTaxChange}
          validateReduction={this.validateReductionChange}
          changeReduction={this.handleReductionChange}
          validateCredit={this.validateCreditChange}
          changeCredit={this.handleCreditChange}
          changeDiscountValue={this.changeDiscountValue}
          onBuyerConfirmOrder={this.buyerConfirmOrder}
          onPlaceOrder={this.placeOrder}
          onSellerConfirmOrder={this.sellerConfirmOrder}
          buyerMembers={members}
        />
        <SmartTable
          statusColorRed={isTrackOrderPage}
          data={data}
          fields={fields}
          fieldsMobile={fieldsForMobile}
          sortableFields={sortableFields}
          rowClassName={row =>
            `
              ${updatedClassname(this, `row-${row.id}`, `${row.quantity}-${row.discount}-${!row.isChild && row.diff}`)}
              ${currentActivity && currentActivity.orderItemId && currentActivity.orderItemId === row.id && 'highlighted'}
            `
          }
          isInvoiceDetail
        />
        <Lightbox
          currentImage={currentImage}
          images={this.lightboxImages}
          isOpen={lightboxIsOpen}
          onClickImage={this.handleClickLightboxImage}
          onClickNext={this.gotoNextImage}
          onClickPrev={this.gotoPreviousImage}
          onClickThumbnail={this.gotoImage}
          onClose={this.closeLightbox}
          showThumbnails
        />
        {/* <BottomPanel
          changeDeliveryFee={this.handleDeliveryFeeChange}
          changeDiscountValue={this.changeDiscountValue}
          editDisabled={editDisabled}
          fields={fields}
          formatMessage={formatMessage}
          info={order}
          isRestaurant={isRestaurant}
          onBuyerConfirmOrder={this.buyerConfirmOrder}
          onPlaceOrder={this.placeOrder}
          onSellerConfirmOrder={this.sellerConfirmOrder}
          orderRequesting={orderRequesting}
          placeOrder={order.type === 'PO' && order.isDraft}
          refundedAmount={refundedAmount}
          totalDue={totalDue}
          currentActivity={currentActivity}
        /> */}
        {order.type === 'SO' && (
          <div className="d-flex justify-content-center" style={{ padding: '10px 0' }}>
            <Button
              classes={{ root: classes.btnSaveAndEmail, disabled: classes.btnDisabled }}
              disabled={pristine}
              onClick={this.handleEmailCustomer}
            >
              {formatMessage('SAVE AND EMAIL CUSTOMER')}
            </Button>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...selectState('options', 'globals')(state, 'globals'),
  ...selectState('options', 'tags')(state, 'tags'),
  ...selectState('members', 'members')(state, 'members'),
});

export default compose(
  setDisplayName('InvoiceDetail'),
  connect(
    mapStateToProps,
    dispatch => ({
      ...dispatchRestMaker([
        [orderItemsActions, 'orderItem'],
        [memberActions, 'member'],
      ])(dispatch),
      sendOrderUpdateEmail: orderId => dispatch(sendOrderUpdateEmail(orderId, {})),
    }),
  ),
  immutableToJS,
  withStyles(styles),
)(InvoiceDetail);
